import {Calendar, ClipboardCheck, Eye, TrendingUp, Users} from 'lucide-react';

const classes = [
    {
        name: 'ریاضیات پیشرفته - گروه A',
        students: 24,
        nextSession: 'شنبه 10:00',
        performance: 85,
        color: 'from-blue-500 to-blue-600'
    },
    {
        name: 'فیزیک کوانتوم',
        students: 18,
        nextSession: 'یکشنبه 14:00',
        performance: 78,
        color: 'from-purple-500 to-purple-600'
    },
    {
        name: 'شیمی تجزیه',
        students: 22,
        nextSession: 'دوشنبه 09:00',
        performance: 92,
        color: 'from-green-500 to-green-600'
    },
    {
        name: 'آزمایشگاه فیزیک',
        students: 15,
        nextSession: 'دوشنبه 16:00',
        performance: 88,
        color: 'from-orange-500 to-orange-600'
    },
];

export default function ClassesSection() {
    return (
        <div className=" rounded-xl shadow-sm border dark:border-gray-600 border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
                <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                    مشاهده همه
                </button>
                <h2 className="text-lg font-bold  ">کلاس‌های من</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {classes.map((cls, index) => (
                    <div
                        key={index}
                        className="border dark:border-gray-600 border-gray-200 rounded-lg p-4 hover:shadow-md transition-all duration-200 group"
                    >
                        <div className="flex items-start justify-between mb-3">
                            <div
                                className={`w-10 h-10 bg-gradient-to-br ${cls.color} rounded-lg flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform duration-200`}>
                                <Users className="w-5 h-5 text-white"/>
                            </div>
                            <div className="text-right flex-1 mr-3">
                                <h3 className="font-semibold   mb-1">{cls.name}</h3>
                                <div className="flex items-center gap-2 text-sm   justify-end">
                                    <span>{cls.students} دانشجو</span>
                                    <Users className="w-4 h-4"/>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-2 text-sm   mb-3 justify-end">
                            <span>جلسه بعد: {cls.nextSession}</span>
                            <Calendar className="w-4 h-4  "/>
                        </div>

                        <div className="mb-4">
                            <div className="flex items-center justify-between mb-1">
                                <span className="text-xs font-medium  ">{cls.performance}%</span>
                                <span className="text-xs  ">عملکرد کلاس</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div
                                    className={`bg-gradient-to-r ${cls.color} h-2 rounded-full transition-all duration-300`}
                                    style={{width: `${cls.performance}%`}}
                                ></div>
                            </div>
                        </div>

                        <div className="flex gap-2">
                            <button
                                className="flex-1 px-3 py-2 bg-gray-100 hover:bg-gray-200   rounded-lg text-xs font-medium transition-colors flex items-center justify-center gap-1">
                                <TrendingUp className="w-3 h-3"/>
                                ثبت نمره
                            </button>
                            <button
                                className="flex-1 px-3 py-2 bg-gray-100 hover:bg-gray-200   rounded-lg text-xs font-medium transition-colors flex items-center justify-center gap-1">
                                <ClipboardCheck className="w-3 h-3"/>
                                حضور و غیاب
                            </button>
                            <button
                                className="flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-medium transition-colors flex items-center justify-center gap-1">
                                <Eye className="w-3 h-3"/>
                                مشاهده
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
